import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gk3gysqy6: FaireProductEntity = {
  token: "p_5gk3gysqy6",
  type: "product",
  name: "Beanie for Infants  |  Bubba Toddler Beanie",
  brandToken: "b_szmga73tgk",
  brandName: "Knuckleheads Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/f9af084a703a76f8277761503a4e2e7a6176ae4dc3f4a59a7882694b0d613a71.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f469452dbc87cb4168dbbc3e55474a52bac82d4d3d819450ca3d55f5c6a086d.png",
    "https://cdn.faire.com/fastly/dd5326339771824771610c94bf3bb9fde509d13b648222e094d0dde7b48c396b.png",
    "https://cdn.faire.com/fastly/74e7f8ed81fd014f84160aca3aa8dc41434f15b5ce386ccb1020585f53456fca.png",
    "https://cdn.faire.com/fastly/e75768f72759656c4d2da857456f023f1a0ef23f5040345db00cd5e0a1bd5371.png",
    "https://cdn.faire.com/fastly/b206dbbfa3907e220cd28e13cf5a590b4a1bae1963352ec99b151d0db73b61a9.png",
    "https://cdn.faire.com/fastly/3aa225834ddf6bd75713d92e4fc42a0f7a46fbf2953b0d24d8ee0757b6a3ca96.png",
    "https://cdn.faire.com/fastly/18101f047e446d5a513a58f6d131184f3bff3c5cd0361fdc7c340583588a709d.png",
    "https://cdn.faire.com/fastly/558fafedef71d33aeefa9e24140eec565b4a39f1add9077ca8f3de4073566de6.png",
    "https://cdn.faire.com/fastly/5d17c3aa71929fa40250c783b1a8afe1d4fced78473cdb8de29884cd6aa6ea2f.png",
    "https://cdn.faire.com/fastly/79b3b027e72cece96a6cd7d724c4ba1a2768db164363fd922fff0f88429d5acb.png",
    "https://cdn.faire.com/fastly/df1e172aff00fb4180368a8e0b7779409c97e18b8e08459f721b6e01901aa5de.png",
    "https://cdn.faire.com/fastly/d48814da08fa9d6f537d07ba9a430bf7195443ff9827843a3046de6ce9025884.png",
    "https://cdn.faire.com/fastly/140be95fd5699b45ce9cfe834dd2eb28a602f680924cfde84b846f48a4c1e7af.png",
    "https://cdn.faire.com/fastly/a8bae79b3812bcd3f86f0ee6135a411b50de32322fec539d36d9bab97f9274bc.png",
    "https://cdn.faire.com/fastly/d58e48674135587e339dd683a28abe121b72aa6afec111263c6a6c6a154b09d3.png",
    "https://cdn.faire.com/fastly/e12f909d6d9c493c5734dc5bbb5bb884266184ef6b4a894df48d093c83d14c60.png",
  ],
  priceDollars: 11,
  description:
    "\nShop the Bubba Toddler Beanie Collection, available in a variety of colors and perfect for little ones. These cozy beanies for infants, beanies for newborns, and infant winter beanies are designed to keep your child warm and stylish during the colder months. Featuring a trendy Bubba patch, these beanies offer both comfort and durability, making them an essential accessory for any winter wardrobe. Ideal for everyday wear or outdoor adventures, this beanie is a must-have for infants and toddlers alike.\n\n\n\n\n",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:59.091Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
